import { gql } from "@apollo/client";

import CommonGoalArtifactFragment from "@graphql/common-goal-artifact-fragment";

export const RoleBasedAssessmentGoalFragment = gql`
  ${CommonGoalArtifactFragment}
  fragment RoleBasedAssessmentGoalFragment on GoalArtifactNode {
    ...CommonGoalArtifactFragment
    competencyRelations(roleId: $roleId) {
      edges {
        node {
          id
          competencyId
          roleId
        }
      }
    }
  }
`;

export default gql`
  ${RoleBasedAssessmentGoalFragment}
  query getDevelopmentGoalsRelatedToCompetenciesQuery(
    $roleId: Int!
    $profileId: Int!
    $competencyIds: [Int]!
  ) {
    careerRole(id: $roleId) {
      id
      developmentGoals(
        goalOwners: [$profileId]
        goalCompetencyIds: $competencyIds
        goalStates: [open, draft]
      ) {
        edges {
          node {
            ...RoleBasedAssessmentGoalFragment
          }
        }
      }
    }
  }
`;
